module.exports = __webpack_public_path__ + "static/img/popup_bg.a5e399b0.png";